/**
 *
 * UserGroupFilter
 *
 */
import { UserGroupPicker } from 'app/components/pickers/AutocompletePickers/UserGroupPicker';
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';

export const UserGroupFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<string> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <UserGroupPicker
      value={props.value}
      onChange={handleOnChange}
      size="small"
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      ariaLabel={props.label}
      id={props.id}
    />
  );
};
export default UserGroupFilter;
